import React, { useEffect } from 'react';
import { AccessPoints } from '../components/Home/AccessPoints';
import { FinalCTA } from '../components/Home/FinalCTA';
export const JoinNow = () => {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="pt-20 bg-white" data-id="element-3487">
      {/* Hero Section */}
      <section className="relative py-16 border-b border-gray-200" data-id="element-3488">
        <div className="absolute inset-0 z-0" data-id="element-3489">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/veE5AXEU4CEztbBqZpUQcx/coverrs.png" alt="The Networking Salon" className="w-full h-full object-cover grayscale" data-id="element-3490" />
          <div className="absolute inset-0 bg-black bg-opacity-50" data-id="element-3491"></div>
        </div>
        <div className="container mx-auto px-4 relative z-10" data-id="element-3492">
          <div className="max-w-3xl mx-auto text-center" data-id="element-3493">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6" data-id="element-3494">
              Join The Networking Salon
            </h1>
            <p className="text-xl text-gray-200 mb-8" data-id="element-3495">
              Choose your pathway into our community based on your goals and
              commitment level
            </p>
          </div>
        </div>
      </section>
      {/* Access Points Section */}
      <AccessPoints data-id="element-3496" />
      {/* Explanation Section */}
      <section className="py-16 bg-white border-t border-gray-200" data-id="element-3497">
        <div className="container mx-auto px-4" data-id="element-3498">
          <div className="max-w-3xl mx-auto" data-id="element-3499">
            <h2 className="text-3xl font-bold text-gray-800 mb-6 text-center" data-id="element-3500">
              Choose Your Community Experience
            </h2>
            <p className="text-gray-700 mb-6" data-id="element-3501">
              The Networking Salon offers multiple ways to engage with our
              community, each designed to meet you where you are on your
              professional journey.
            </p>
            <p className="text-gray-700 mb-6" data-id="element-3502">
              Whether you're looking for a free entry point to explore what we
              offer, seeking the full benefits of our curated community, or
              ready for personalized strategic guidance - we have a pathway
              that's right for you.
            </p>
            <p className="text-gray-700 mb-6" data-id="element-3503">
              Select the option above that best aligns with your goals and level
              of commitment. Each pathway offers a unique set of benefits and
              opportunities to connect, grow, and thrive within our ecosystem.
            </p>
          </div>
        </div>
      </section>
      {/* Final CTA */}
      <section className="py-16 bg-gray-50" data-id="element-3504">
        <div className="container mx-auto px-4 text-center" data-id="element-3505">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-8 max-w-3xl mx-auto" data-id="element-3506">
            Join Today and Transform How You Connect
          </h2>
          <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto" data-id="element-3507">
            Stop collecting business cards. Start building relationships that
            change your future.
          </p>
        </div>
      </section>
    </div>;
};